import { PayloadAction } from "@reduxjs/toolkit";
import { ProfileState } from "@/components/ProfileSideDrawer/redux/types";

const ProfileReducer = {
  setOnboardingJourneySteps: (state: ProfileState, action: PayloadAction<any>) => {
    state.onboardingJourneySteps = action.payload;
  },
  setIsProfileOpen: (state: ProfileState, action: PayloadAction<boolean>) => {
    state.isProfileOpen = action.payload;
  },
  setIsOpenOnboardingSteps: (state: ProfileState, action: PayloadAction<boolean>) => {
    state.isOpenOnboardingSteps = action.payload;
  },

  setLoading: (state: ProfileState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },

  setError: (state: ProfileState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
};

export default ProfileReducer;
